<div class="device-indicator text-center" [ngClass]="{ 'closed-sidebar': !isExpanded }">
  <!-- Content for expanded sidebar -->
  <div
    *ngIf="isExpanded"
    [ngClass]="{ 'text-gray-500': !isRegistered }"
    class="flex flex-row gap-2 items-center"
  >
    <div class="icon-container">
      <mat-icon *ngIf="isRegistered; else notRegisteredBlock" class="align-middle cursor-pointer">
        phonelink
      </mat-icon>
      <ng-template #notRegisteredBlock>
        <mat-icon
          matTooltip="Your Device is not Linked!"
          class="align-middle cursor-pointer text-danger"
        >
          phonelink_off
        </mat-icon>
      </ng-template>
    </div>
    <span class="text-sm indicator-label" [ngClass]="{ 'text-danger': !isRegistered }">
      {{ isRegistered ? 'Registriert' : 'Unregistriert' }}
    </span>
  </div>

  <!-- Content for collapsed sidebar -->
  <div *ngIf="!isExpanded" [ngClass]="{ 'text-gray-500': !isRegistered }">
    <div class="icon-container">
      <mat-icon
        *ngIf="isRegistered; else collapsedNotRegisteredBlock"
        class="align-middle cursor-pointer"
      >
        phonelink
      </mat-icon>
      <ng-template #collapsedNotRegisteredBlock>
        <mat-icon class="align-middle cursor-pointer text-danger"> phonelink_off </mat-icon>
      </ng-template>
    </div>
  </div>
</div>
